import { canStep } from './free-move';
const ALL_DIRECTIONS = ['up', 'down', 'left', 'right'];
/**
 * Module 35 (WP-35.16.5) — the free-slide equivalent: a board is stuck when no
 * block can take a single step in any direction it is allowed to move.
 *
 * It is far rarer than in the single-axis model (a free block only needs one open
 * neighbour cell, and gates never block movement), but a fully packed board is
 * still possible, and the win/stuck check runs after every move regardless.
 *
 * WP-50.4 reviewed this against the settled exit rule and changed nothing, on
 * purpose. "Stuck" is a question about the FIRST step — can anything move at all
 * — and where a slide would end has no bearing on whether it can begin. The exit
 * rule only ever ends a slide EARLIER, so it can neither create nor clear a
 * stuck board: a block with an open neighbour cell still has one.
 */
export function hasNoFreeMoves(state) {
    const { blocks, puzzle } = state;
    for (const block of blocks) {
        for (const dir of ALL_DIRECTIONS) {
            if (canStep(block, dir, blocks, puzzle.gridSize))
                return false;
        }
    }
    return true;
}
